module.exports = __webpack_public_path__ + "6231192ffcdedf1ab4aa0680a1d84211.MP3";